/** @format */

import decodePolyline from 'decode-google-map-polyline';
import { Polyline } from 'google-maps-react'; //폴리라인디코드 라이브러리
import decodeLevels from './DecodeLevels';

const createPolyLine = (it) => {
  const setColor = [
    '#FF0000',
    '#FF8000',
    '##FFFFFF',
    '#80FF00',
    '#00FF00',
    '#00FFFF',
    '#0080FF',
    '#0000FF',
    '#7F00FF',
    '#FF00FF',
    '#FF007F',
    '#808080',
  ];


  return (
    <Polyline
      key={it.rideId}
      options={{
        path: decodePolyline(it.summary_polyline), //원래는 it
        levels: decodeLevels(
          'BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB'
        ),
        strokeWeight: 1,
        strokeColor: setColor[Math.floor(Math.random() * 12)],
        strokeOpacity: 1.0,
        strokeWeight: 2,
      }}
    />
  );
};

export default createPolyLine;
